export const STATUS_TABS_CUSTOMER_DETAILS: Array<string> = [
  'basicinformation',
  'contacts',
  'notes',
  'tasks',
  'files',
  'jobs',
  'activities',
];

export const CUSTOMER_TYPES_ORGANIZATION = 'organization';
export const CUSTOMER_TYPES_CONTACT = 'contact';
